<section class="home-landing">
    <header class="home-landing__topbar">
        <a class="home-brand" routerLink="/home" aria-label="Memoria Bibliográfica">
            <mat-icon>auto_stories</mat-icon>
            <span>Memoria Bibliográfica</span>
        </a>
    </header>

    <main class="home-landing__content">
        <section class="home-copy" aria-labelledby="home-title">
            <h1 id="home-title"><span>Tu biblioteca,</span><span>tu memoria.</span></h1>
            <p class="home-copy__lead">Guarda, organiza y redescubre los libros que han dejado huella en tu vida.</p>
            <div class="home-copy__rule" aria-hidden="true"></div>
            <div class="home-actions">
                <a class="home-action home-action--primary" routerLink="/register">
                    <mat-icon>person_add</mat-icon>
                    <span>Date de alta</span>
                    <small>Crea tu cuenta y empieza ahora</small>
                </a>
                <a class="home-action" routerLink="/login">
                    <mat-icon>login</mat-icon>
                    <span>Inicia sesión</span>
                    <small>Accede a tu cuenta y continúa</small>
                </a>
            </div>
        </section>

        <aside class="home-quote" aria-label="Cita literaria">
            <div class="home-quote__ornament" aria-hidden="true"></div>
            <blockquote>
                <p>{{readingQuote.texto}}</p>
                <footer>{{readingQuote.autor}}</footer>
            </blockquote>
        </aside>
    </main>

    <footer class="home-landing__footer">
        <article>
            <mat-icon>menu_book</mat-icon>
            <div>
                <h2>Organiza tus lecturas</h2>
                <p>Lleva el registro de favoritos, pendientes y libros en marcha.</p>
            </div>
        </article>
        <article>
            <mat-icon>local_offer</mat-icon>
            <div>
                <h2>Recuerda lo importante</h2>
                <p>Añade notas, citas y valoraciones para volver a cada historia.</p>
            </div>
        </article>
        <article>
            <mat-icon>bar_chart</mat-icon>
            <div>
                <h2>Tu historia lectora</h2>
                <p>Explora estadísticas y revive cada página leída.</p>
            </div>
        </article>
    </footer>
</section>
